export const CLASS_NAME = 'cst-dashboard-card-relative-flux'
